import React from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import { tableHeaderStyles } from "../../styles/ReactSelectStyles";
import { HolidayType } from "./HolidayTypeList";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { MoreVertical } from "react-feather";
import { useTranslation } from "react-i18next";

interface Props {
  data: HolidayType[];
  onEdit: (data: HolidayType) => void;
  onDelete: (id: number) => void;
}

export const getColumns = (
  onEdit: Props["onEdit"],
  onDelete: Props["onDelete"],
  t: (key: string) => string
): TableColumn<HolidayType>[] => [
  {
    name: t("Sl.No"),
    cell: (_row, index) => (index + 1).toString(),
    width: "10%",
    minWidth: "80px",
    sortable: false,
  },
  {
    name: t("HolidayType"),
    selector: (row) => row.typeName,
    sortable: true,
    width: "25%",
    minWidth: "120px",
    maxWidth: "200px",
  },
  {
    name: t("Description"),
    selector: (row) => row.description,
    sortable: true,
    width: "50%",
    minWidth: "200px",
    wrap: true,
  },
  {
    name: t("Action"),
    cell: (row) => (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className="cursor-pointer">
          <MoreVertical size={18} />
        </DropdownToggle>
        <DropdownMenu container="body">
          <DropdownItem onClick={() => onEdit(row)}>{t("Edit")}</DropdownItem>
          <DropdownItem onClick={() => onDelete(row.id)}>
            {t("Delete")}
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    width: "15%",
    minWidth: "80px",
    center: true,
  },
];

const HolidayTypeTable: React.FC<Props> = ({ data, onEdit, onDelete }) => {
  const { t } = useTranslation();
  return (
    <DataTable
      columns={getColumns(onEdit, onDelete, t)}
      data={data}
      customStyles={tableHeaderStyles}
      striped
      highlightOnHover
      pagination
      responsive
      noHeader
      style={{ width: "100%" }}
    />
  );
};

export default HolidayTypeTable;
